import React from 'react';
import { CardImg } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
const AivaProductListItem = ({
  item,
  SelectedProduct,
  SelectedProductID,
  w,
  voucher,
}) => {
  return (
    <div
      className={`row col-md-12`}
      style={{ cursor: 'pointer' }}
      onClick={(e) =>
        null
      }
    >
      <div
        className="card col-md-12 aiva-border text-center"
      >
        <div className="pt-5 pb-5 d-flex flex-lg-column flex-md-row flex-sm-row flex-column card-body">
          <div className="price-top-part">
            <h5 className="mb-0 font-weight-semibold color-theme-1 mb-3  text-center  aiva">
              Aiva Friend`s
            </h5>
            <div className="mb-3 text-default  text-center">
              <p> Access Complete Voucher distribution
              </p><p>
                features with simple, pay-as-you-go pricing
              </p>
            </div>
            <p className='text-center mb-2'>
              <h2><strong> 9 %</strong></h2>
            </p>
            <p className='text-center mb-4'>Per successfull vouchere transaction</p>
            {/* <p className="text-muted text-small">+ 5% booking commission</p> */}
            <i
              className="demo-icon simple-icon-check activeSubscription"
              id="nametip"
            ></i>
          </div>
          <div className=" d-flex-justify-content-center flex-column flex-grow-1">
            <ul className='aiva-list-item '>
              <li className='justify-content-center my-3 '>
                <FontAwesomeIcon icon={faCheck} ></FontAwesomeIcon> <span className='ml-2'> Everything you need to manage and distribute vouchers</span>
              </li>
              <li className='justify-content-center my-3 '>
                <FontAwesomeIcon icon={faCheck} ></FontAwesomeIcon> <span className='ml-2'>        No setup fee, monthly fees or hidden fees</span>
              </li>
              <li className='justify-content-center my-3 '>
                <FontAwesomeIcon icon={faCheck} ></FontAwesomeIcon><span className='ml-2'>   Include payment gateway fees</span>
              </li>
              <li className='justify-content-center my-3 '>
                <FontAwesomeIcon icon={faCheck} ></FontAwesomeIcon>  <span className='ml-2'> Get continuous features updates</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(AivaProductListItem);
